"use client";

import {JSX} from "react";

import {useModel} from "@/shared/hooks/state-management/use-model";
import {useModelSnapshot} from "@/shared/hooks/state-management/use-model-snapshot";
import {ButtonBase} from "@/shared/ui/buttons/button-base";
import {ButtonLike} from "@/shared/ui/buttons/button-like";
import {Typography} from "@/shared/ui/data-display/typography";
import {TextField} from "@/shared/ui/form/fields/text-field";
import {TextareaField} from "@/shared/ui/form/fields/textarea-field";
import {VideoLoader} from "@/shared/ui/media";
import {Modal} from "@/shared/ui/overlay/modal";

import {VideoModalModel, type VideoModalModelInstance} from "./video-modal.model";

import "./styles/video-modal.scss";

// Valtio model - only used in client components, serialization check not applicable
type VideoModalProps = {
    model: VideoModalModelInstance;
};

export function VideoModal(props: VideoModalProps): JSX.Element {
    const [internalModel] = useModel(VideoModalModel);
    const model = props.model ?? internalModel;
    const snapshot = useModelSnapshot(model);

    return (
        <Modal
            isOpen={snapshot.state.isOpen}
            onClose={() => model.close()}
            className="video-modal"
            contentClassName="video-modal__content"
            ariaLabel="Video player"
        >
            <div className="video-modal__player">
                {snapshot.state.url && <VideoLoader src={snapshot.state.url} controls showPlayButton={false} className="video-modal__video-loader" />}
            </div>

            <div className="video-modal__header-row">
                <Typography as="h3" size={{desktop: 16, mobile: 14}} weight={600} className="video-modal__title">
                    {snapshot.state.title}
                </Typography>
                <ButtonLike likes={0} dislikes={0} />
            </div>

            <div className="video-modal__form">
                <TextareaField model={model.fields.comment} placeholder="Add your comment" className="video-modal__comment" />
                <div className="video-modal__row">
                    <TextField model={model.fields.name} placeholder="Full Name" />
                    <TextField model={model.fields.email} placeholder="Email" />
                    <ButtonBase as="button" variant="primary" size="sm">
                        Submit
                    </ButtonBase>
                </div>
            </div>
        </Modal>
    );
}
